export default {
  globalLayoutName: {
    company: {
      create: 'Stickyweb Company create',
      update: 'Stickyweb Company detail',
      list: "Stickyweb Company list",
    },
    person: {
      create: "Stickyweb Person create",
      update: "Stickyweb Person detail",
      list: "Stickyweb Person list",
    },
    dashboard: {
      list: "Stickyweb Dashboard",
      update: "Dashboard",
    },
    invoice: {
      list: "Stickyweb Invoice list",
      create: "Stickyweb Invoice create",
      update: "Stickyweb Invoice detail"
    }
  },
  crudModeSelect: {
    view: {
      title: "View layouts for",
    },
    create: {
      title: "Create layout for",
    },
  },
  text: {
    title: "Explanation",
    intro: {
      multi: "There are 3 different types of layouts that can be used, the {{module}} list, {{module}} detail and when creating a new {{module}}. ",
      default: "A default layout is provided by the system. You can create a new layout that is available for all users, or a private one, for personal use.",
    },
    legenda: {
      title: "Legenda",
      userChosen: "Your default layout",
      widgets: 'Allows you to add and remove widgets from the layout',
      rename: "Change the layouts name",
      delete: "Delete the layout",
    },
  },
  list: {
    noLayoutInList: "No layouts created yet",
    newLayout: {
      title: "New layout",
    },
    private: {
      title: 'Private layouts',
    },
    client: {
      title: 'Client layouts',
    },
    global: {
      title: 'Default layout',
    },
  },
  createLayout: {
    buttons: {
      create: "Create layout",
      cancel: "Cancel",
    },
    firstTabName: "Main",
  },
  createEditLayout: {
    title: "Layout",
    buttons: {
      addTab: "Add tab",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
    },
    input: {
      name: {
        label: "Name",
      },
      private: {
        label: "Private",
      },
    },
  },
  buttons: {
    switchLayout: "Switch layout",
  },
  api: {
    id: {
      notNull: "Unknown layout",
    },
    name: {
      notNull: "Set a name for the layout",
    },
    tabs: {
      notNull: "Add at least one tab.",
    },
  },
}
